import { NavigatorCruiseRecommendationNotificationData } from "@cruisen/contract"
import { CruiseCardsCarousel } from "../../../cards/CruiseCardsCarousel"

export const NavigatorCruiseRecommendation = ({
  data,
}: {
  data: NavigatorCruiseRecommendationNotificationData
}) => {
  return (
    <>
      <CruiseCardsCarousel data={data} testID="navigator-cruise-recommendation" />
    </>
  )
}
